import { useNavigate } from "react-router-dom";

export default function UnAuthorized() {

    const navigate = useNavigate();

    return (
        <>
            <div className="container d-flex justify-content-center align-items-center" style={{ height: '92vh' }}>
                <div className="text-center" style={{ letterSpacing: '1px' }}>
                    <h4>Page Not Found</h4>
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            marginTop: "1rem",
                            padding: "0.5rem 1rem",
                            background: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                        }}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </>
    )
}